import { render, staticRenderFns } from "./ContactInfoRow.vue?vue&type=template&id=083c8120&scoped=true&"
import script from "./ContactInfoRow.vue?vue&type=script&lang=js&"
export * from "./ContactInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoRow.vue?vue&type=style&index=0&id=083c8120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c8120",
  null
  
)

export default component.exports